import { any, number } from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const PrimaryLayer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const SpetContent = styled.div`
  width: 15%;
  font-size: 2.2em;
  color: var(--second);
  font-family: 'imlbold'; font-weight: bold;
  @media screen and (max-width:960px) {
    display: none
  }
`

const Content = styled.div`
  width: 81%;
  @media screen and (max-width:960px) {
    width: 100%;
  }
`

const SectionDivider = props => (
  <PrimaryLayer>
    <SpetContent>
      Paso {props.step || '1'}
    </SpetContent>
    <Content>
      {props.children || 'hello'}
    </Content>
  </PrimaryLayer>
)

SectionDivider.propTypes = {
  step: number,
  children: any
}

export default SectionDivider
